import { Injectable } from '@angular/core';
import { BaseFirestoreService } from './base-firestore.service';
import { SMBrand } from 'src/app/models/SMBrand';
import { SMOrderBasic } from 'src/app/models/SMOrderBasic';
import { SMReservationSlots } from 'src/app/models/SMReservationSlots';
import { SMTimeSlot } from 'src/app/models/SMTimeSlot';
import { SMTimeSlotStatus } from 'src/app/enums/SMTimeSlotStatus';
import { UserService } from './user.service';
import { SMComment } from 'src/app/models/SMComment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  COLLECTION_NAME = 'Brands';
  brandList: SMBrand[] = [];
  brandIDList: string[] = [];
  constructor(private base: BaseFirestoreService, private userService: UserService) {
  }

  async getBrand(brandID: string): Promise<SMBrand> {
    if (this.brandIDList.indexOf(brandID) > -1 ) {
      return this.brandList[this.brandIDList.indexOf(brandID)];
    }
    return await this.getBrandFromFirebase(brandID);
  }

  async getBrandFromFirebase(brandID): Promise<SMBrand> {
    const docRef = this.base.getDocRef(brandID, this.COLLECTION_NAME);
    const doc = await this.base.getDoc(docRef);
    if (doc.exists) {
      const data: SMBrand = Object.assign(doc.data());
      if (this.brandIDList.indexOf(brandID) < 0) {
        this.brandList.push(data);
        this.brandIDList.push(brandID);
      }
      return data;
    }
    return null;
  }

  async getAllBrands(): Promise<SMBrand[]> {
    return new Promise(resolve => {
      this.base.getCollectionRef('Brands').valueChanges({idField: 'id'}).subscribe((data: any) => resolve(data));
    });
  }

  async createOrderRequest(brandID: string, brand: SMBrand, order: SMOrderBasic): Promise<boolean> {
    brand.orders.push(order);
    const user = await this.userService.getUser();
    user.orders.push(order);
    await this.userService.updateUser(user);
    return await this.base.updateRecord(brandID, brand, this.COLLECTION_NAME);
  }

  async getTimeSLots(brandID, date: Date): Promise<SMTimeSlot[]> {
    const docRef = this.base.getDocRef(brandID, this.COLLECTION_NAME);
    const slotRef = docRef.collection('reservations').doc(date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear() );
    const slotDoc = await this.base.getDoc(slotRef);
    if (slotDoc.exists) {
      return this.generateTimeSlots(slotDoc.data().slots);
    } else {
      const slots = new SMReservationSlots();
      slotRef.set({slots: slots.slots});
      return this.generateTimeSlots(slots.slots);
    }
  }

  async updateOrder(brand: SMBrand, order: SMOrderBasic): Promise<boolean> {
    brand.orders.forEach(item => {
      if (item.id === order.id) {
        item.reservationDate = order.reservationDate;
        item.reservationHour = order.reservationHour;
        item.customerNote = order.customerNote;
        item.status = order.status;
      }
    });
    const user = await this.userService.getUser();
    user.orders.forEach(item => {
      if (item.id === order.id) {
        item.reservationDate = order.reservationDate;
        item.reservationHour = order.reservationHour;
        item.customerNote = order.customerNote;
        item.status = order.status;
      }
    });
    await this.userService.updateUser(user);
    return await this.base.updateRecord(brand.brandID, brand, this.COLLECTION_NAME);
  }

  generateTimeSlots(data): SMTimeSlot[] {
    const result: SMTimeSlot[] = [];
    for (let i = 0; i < data.length; i++) {
      const slot: SMTimeSlot = {
        code: data[i].code,
        end: i + 1,
        slot: (i < 10 ? '0' + i : i) + ':00 - ' + (i + 1 < 10 ? '0' + (i + 1) : i + 1) + ':00',
        start: i,
        status: data[i].count < 5 ? SMTimeSlotStatus.NOT_SELECTED : SMTimeSlotStatus.DISABLED
      };
      result.push(slot);
    }
    for (const slot of result) {
      if (slot.status !== SMTimeSlotStatus.DISABLED) {
        slot.status = SMTimeSlotStatus.SELECTED;
        break;
      }
    }
    return result;
  }

  async addComment(brand: SMBrand, comment: SMComment): Promise<boolean> {
    if (!brand.comments) {
      brand.comments = [];
    }
    brand.comments.push(comment);
    return await this.base.updateRecord(brand.brandID, brand, this.COLLECTION_NAME);
  }

  async updateBrand(brand: SMBrand): Promise<boolean> {
    const result = await this.base.updateRecord(brand.id, brand, this.COLLECTION_NAME);
    return result;
  }

  async getBrands(): Promise< Observable<any[]>> {
    return this.base.getFirestore().collection(this.COLLECTION_NAME).valueChanges({ idField: 'id' });
  }

  async createBrand(newBrand:SMBrand): Promise<SMBrand> {
    const recordRef: any =  await this.base.createRecord(newBrand, this.COLLECTION_NAME);
    const docRef = await this.base.getDocRef(recordRef.path.split('/')[1],this.COLLECTION_NAME);
    const doc = await this.base.getDoc(docRef);

    if (doc.exists) {
      const data: SMBrand = Object.assign(doc.data());
      data.id = doc.id;
      return Promise.resolve(data);
    }

    return Promise.reject('marka oluşturulamadı');
  }
}
